<h4 mat-dialog-title class="px-5" data-cy="create-task-label">
    {{'task_label.new' | translate}} 
</h4>
<div mat-dialog-content class="pt-3">
        <div class="form-group px-3 mb-3">
            <label for="name" class="text-secondary">
                {{'task_label.name' | translate}}             
            </label>
            <input type="text" class="form-control" id="name" name="name" [formControl]='taskLabelNameCtrl'>
        </div>
        <div class="form-group px-3">
            <label class="text-secondary pb-2">{{'task_label.color' | translate}}</label>
            <div class="color-palette" role="radiogroup">
                @for (color of availableColors; track color) {
                    <button class="color-palette-item" type="button" aria-checked="false" role="radio" tabindex="-1"
                            [ngStyle]="{ 'background-color':  color}"
                            [ngClass]="{'selected': selectedColor === color}"
                            (click)="selectColor(color)">
                            @if(color === selectedColor) {
                                <div class="color-palette-item-check">
                                    <i class="fa-solid fa-check"></i>
                                </div>
                            }
                    </button>
                }
            </div>
        </div>
</div>
<div mat-dialog-actions>
    <button type="button" class="btn btn-default" data-cy="user-request-modal-close" (click)="close()">
        {{'close' | translate}}
    </button>
    <button type="button" class="btn btn-primary" data-cy="user-request-modal-submit"
            [disabled]="taskLabelNameCtrl.invalid"
            (click)="save()">{{'Save' | translate }} 
        <i class="far fa-check"></i>
    </button>
</div>
  

